const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'INCUBACAO_MATURIDADE_ANO1_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'INCUBACAO_MATURIDADE_ANO1_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'INCUBACAO_MATURIDADE_ANO1_LISTADO':
            return {
				...state,
				lista: action.payload.data.filter(item => item.ano == 1)
			};

        default:
            return state;
    }
}
